import axios from 'axios'
import { DAYDACO_AUTH_KEY } from './authService'

export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:8000/api'
export const DEV_TOKEN = process.env.REACT_APP_DEV_TOKEN

export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000, // 30 seconds to handle billing setup processing
})

api.interceptors.request.use(
  (config) => {
    // Fetch the token dynamically (e.g., from localStorage or state)
    const sessionToken = localStorage.getItem(DAYDACO_AUTH_KEY)

    if (sessionToken) {
      config.headers.Authorization = `Bearer ${sessionToken}`
    }

    // Debug logging for production issues
    if (config.method === 'patch' && config.url?.includes('/invite/')) {
      console.log('Making PATCH request:', {
        method: config.method,
        url: config.url,
        fullURL: `${config.baseURL}${config.url}`,
        headers: config.headers,
        timeout: config.timeout,
      })
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

api.interceptors.response.use(
  (response) => {
    // Debug logging for successful responses
    if (
      response.config.method === 'patch' &&
      response.config.url?.includes('/invite/')
    ) {
      console.log('PATCH request successful:', {
        status: response.status,
        statusText: response.statusText,
        data: response.data,
        url: response.config.url,
      })
    }
    return response
  },
  (error) => {
    // Debug logging for failed responses
    if (
      error.config?.method === 'patch' &&
      error.config?.url?.includes('/invite/')
    ) {
      console.log('PATCH request failed:', {
        status: error.response?.status,
        statusText: error.response?.statusText,
        data: error.response?.data,
        message: error.message,
        code: error.code,
        url: error.config?.url,
        fullURL: error.config
          ? `${error.config.baseURL}${error.config.url}`
          : 'unknown',
      })
    }
    return Promise.reject(error)
  },
)

export type ErrorData = {
  message: string
  code: string
  param: string
}

export type FetchErrorType = {
  error: {
    response: {
      data: {
        errors: ErrorData[]
      }
    }
  }
}
